import * as types from "./types";
import {
  getNoteAxios,
  deleteNoteAxios,
  postNoteAxios,
  putNoteAxios,
  getNoteByIDAxios,
  getNoteByLeadIDAxios,
} from "./services";

export async function getNoteListAction({ commit }) {
  commit(types.LOADING_NOTE, true);
  try {
    const { data } = await getNoteAxios();
    commit(types.GET_NOTE_LIST, data.result);
  } catch (e) {
    console.log(e);
    throw e;
  } finally {
    commit(types.LOADING_NOTE, false);
  }
}

export async function removeNoteAction({ commit }, payload) {
  commit(types.LOADING_NOTE, true);
  try {
    await deleteNoteAxios(payload);
    commit(types.REMOVE_NOTE, payload);
  } catch (e) {
    console.log(e);
    throw e;
  } finally {
    commit(types.LOADING_NOTE, false);
  }
}

export async function addNoteAction({ commit }, payload) {
  commit(types.LOADING_NOTE, true);
  try {
    await postNoteAxios(payload);
    commit(types.ADD_NOTE, payload);
  } catch (e) {
    console.log(e);
    throw e;
  } finally {
    commit(types.LOADING_NOTE, false);
  }
}

export async function updateNoteAction({ commit }, payload) {
  commit(types.LOADING_NOTE, true);
  try {
    await putNoteAxios(payload);
    commit(types.UPDATE_NOTE, payload);
  } catch (e) {
    throw e;
  } finally {
    commit(types.LOADING_NOTE, false);
  }
}

export async function getNoteByIdAction({ commit }, payload) {
  commit(types.LOADING_NOTE, true);
  try {
    await getNoteByIDAxios(payload);
    commit(types.GET_NOTE_BY_ID, payload);
  } catch (e) {
    console.log(e);
    throw e;
  } finally {
    commit(types.LOADING_NOTE, false);
  }
}

export async function getNoteByLeadIdAction({ commit }, payload) {
  commit(types.LOADING_NOTE, true);
  try {
    // await getNoteByLeadIDAxios(payload);
    // commit(types.GET_NOTE_BY_LEADID, payload);
    const { data } = await getNoteByLeadIDAxios(payload);
    commit(types.GET_NOTE_BY_LEADID, data.result);
    console.log("notelisting", data.result);
    //return data.result;
  } catch (e) {
    console.log(e);
    throw e;
  } finally {
    commit(types.LOADING_NOTE, false);
  }
}
